import type {CreateExtArgs} from '@wix/document-manager-core'
import {containableByFullWidthPopup} from '../utils/pageUtils'
import type {CompStructure, Pointer} from '@wix/document-services-types'

export const stripContainerMetaData = {
    fullWidthByStructure: true,
    fullWidth: true,
    containableByStructure: (createExtArgs: CreateExtArgs, compStructure: CompStructure, containerPointer: Pointer) =>
        containableByFullWidthPopup(createExtArgs, containerPointer)
}
